module.exports = __webpack_public_path__ + "assets/icon-insulator-screwIn.376b1b7d.svg";